const initState = {
    isLoading: false,
    data: [],
    error: null,
  };
  
  const PackDetailReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_PACK_DETAIL_LOADING":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_PACK_DETAIL_DATA":
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      case "SET_PACK_DETAIL_ERROR":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
      case "CLEAR_PACK_DETAIL":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: null,
        };
      default:
        return state;
    }
  };
  
  export default PackDetailReducer;